import React from 'react';
import { Box, Button, Grid, Stack } from '@mui/material';
import { useDispatch, useSelector } from 'react-redux';
import {
	resetSearchFields,
	setItemId,
	setSearchText,
	setSearchValue,
} from '@/features/table/attachmentsTableSlice';
import { openDialog } from '@/features/dialog/dialogSlice';
import { useAttachmentsContext } from '@/context/attachmentsContext';
import SearchField from '@/components/SearchField';

export const AttachmentsTableHeader = ({ loading, selectionCount, anyCellsBeingEdited }) => {
	const dispatch = useDispatch();
	const { handleDelete } = useAttachmentsContext();
	const { parentItemId, searchValue, searchText, selectedRows } = useSelector(
		(state) => state.attachmentsTable,
	);

	const handleSearch = () => {
		if (searchText != searchValue) {
			dispatch(setItemId(parentItemId));
			dispatch(setSearchValue(searchText));
		}
	};

	return (
		<Grid container spacing={1} alignItems={'flex-start'}>
			<Grid size={{ sm: 12, md: 6 }}>
				<Box width='100%' pb='1em'>
					<Stack direction='row' spacing={1}>
						<SearchField
							value={searchText}
							disabled={loading || selectionCount > 0 || anyCellsBeingEdited}
							onKeyDown={(e) => {
								if (e.key === 'Enter') {
									handleSearch();
								}
							}}
							onChange={(e) => dispatch(setSearchText(e.target.value))}
							onClick={handleSearch}
							onReset={() => dispatch(resetSearchFields())}
						/>
					</Stack>
				</Box>
			</Grid>
			<Grid
				size={{ sm: 12, md: 6 }}
				container
				justifyContent={'flex-end'}
				alignItems={'start'}
			>
				{selectionCount > 0 && (
					<>
						{selectionCount === 1 && (
							<Box>
								<Button
									variant='table_actions'
									disabled={anyCellsBeingEdited}
									onClick={() => {
										dispatch(
											openDialog({
												dialogName: 'renameFile',
												data: { file: selectedRows[0] },
											}),
										);
									}}
								>
									{selectedRows[0]?.isFolder ? 'Rename' : 'Update'}
								</Button>
							</Box>
						)}

						<Box>
							<Button
								variant='table_actions'
								disabled={anyCellsBeingEdited}
								onClick={() => {
									dispatch(openDialog({ dialogName: 'moveFile' }));
								}}
							>
								Move to
							</Button>
						</Box>

						<Box>
							<Button
								variant='table_actions'
								disabled={anyCellsBeingEdited}
								onClick={handleDelete}
							>
								Delete
							</Button>
						</Box>
					</>
				)}
			</Grid>
		</Grid>
	);
};
